/* dynamic-layout-person-card.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./dynamic-layout-person-card.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import Avatar from '@atlaskit/avatar';
import { Box, Inline, Stack, Text } from '@atlaskit/primitives/compiled';
var PersonCarouselCardStyles = {
  personCardWrapper: "_2rko1qi0 _189ee4h9 _1dqonqa1 _1h6d1l7x _1e0c1txw _2lx21bp4 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _vchhusvi _1ul91018 _1bsb1018",
  contactInfoSection: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _18u0u2gc _1ul9idpf _1bto1l2s"
};
export var DynamicLayoutPersonCard = function DynamicLayoutPersonCard(_ref) {
  var component = _ref.component;
  var personAttributes = component.attributes;
  var _ref2 = personAttributes || {},
    name = _ref2.name,
    job_title = _ref2.job_title,
    avatar_url = _ref2.avatar_url;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: PersonCarouselCardStyles.personCardWrapper
  }, /*#__PURE__*/React.createElement(Inline, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Avatar, {
    appearance: "circle",
    src: avatar_url || '',
    size: "large"
  })), /*#__PURE__*/React.createElement(Box, {
    xcss: PersonCarouselCardStyles.contactInfoSection
  }, /*#__PURE__*/React.createElement(Stack, {
    space: "space.050"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "large",
    maxLines: 1,
    weight: "bold"
  }, name), /*#__PURE__*/React.createElement(Text, {
    size: "small",
    maxLines: 1
  }, job_title)))));
};